import api from './api';

export const blogService = {
   getAll: async (params = {}) => {
      const response = await api.get('/blogs', { params });
      return response.data;
   },

   getById: async (id) => {
      const response = await api.get(`/blogs/${id}`);
      return response.data;
   },

   getBySlug: async (slug) => {
      const response = await api.get(`/blogs/slug/${slug}`);
      return response.data;
   },

   search: async (query, limit = 20, page = 1) => {
      // minimal: true returns only {id, title, slug} the picker only ever
      // renders the title, no need to ship full content/faqs/tags/author.
      // matchTaxonomy: match title, category name or tag name. An empty query
      // lists all published posts (newest first), paged.
      const response = await api.get('/blogs', {
         params: {
            ...(query ? { search: query } : {}),
            status: 'PUBLISHED',
            limit,
            page,
            minimal: true,
            matchTaxonomy: true,
         },
      });
      return response.data;
   },

   create: async (blogData) => {
      const response = await api.post('/blogs', blogData);
      return response.data;
   },

   update: async (id, blogData) => {
      const response = await api.put(`/blogs/${id}`, blogData);
      return response.data;
   },

   delete: async (id) => {
      const response = await api.delete(`/blogs/${id}`);
      return response.data;
   },

   autoSave: async (id, blogData) => {
      const url = id ? `/blogs/autosave/${id}` : '/blogs/autosave';
      const response = await api.post(url, blogData);
      return response.data;
   },

   uploadImage: async (file) => {
      const formData = new FormData();
      formData.append('image', file);
      formData.append('uploadType', 'blog');

      const response = await api.post('/blogs/upload-image', formData, {
         headers: {
            'Content-Type': 'multipart/form-data',
         },
      });
      return response.data;
   },

   uploadCoverImage: async (file) => {
      const formData = new FormData();
      formData.append('coverImage', file);
      formData.append('uploadType', 'blog');

      const response = await api.post('/blogs/upload-cover', formData, {
         headers: {
            'Content-Type': 'multipart/form-data',
         },
      });
      return response.data;
   },
};
